import { createFileRoute } from "@tanstack/react-router";

import { OrdersPage } from "../../../../features/purchasing/orders-page";

export const Route = createFileRoute("/_app/purchasing/orders/")({ component: OrdersPage });
